import { StatusBadge } from '@/components/ui/StatusBadge'
import {
  SUPPLIER_STATUS_LABEL,
  type SupplierStatus,
} from '@/services/suppliers'

export function SupplierStatusBadge({ status }: { status: SupplierStatus }) {
  const active = status === 'ACTIVE'
  return (
    <StatusBadge
      tone={active ? 'success' : 'neutral'}
      label={SUPPLIER_STATUS_LABEL[status]}
    />
  )
}
